import { useJobProgress } from "../../../contexts/JobProgressContext";
import { useEffect, useState } from "react";
import useToast from "../../../hooks/Toast";

const JobProgressToast = ({ progressData, jobId }) => {
  const { removeJob } = useJobProgress();
  const { showToast } = useToast();
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    if (progressData.status === "COMPLETED" || Number(progressData.progress) === 100) {
      const timer = setTimeout(() => {
        removeJob(jobId);
      }, 1000);
      return () => clearTimeout(timer);
    }
    else if (progressData.status === "FAILED") {
      const timer = setTimeout(() => {
        removeJob(jobId);
        // Tracked (COA) jobs show their own error toast
        if (!progressData.tracked) showToast("Failed to copy data", "error");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [progressData.status, progressData.tracked, jobId, removeJob]);

  useEffect(() => {
    if (progressData.status !== "IN_PROGRESS") return;
    setIsStale(false);
    const staleTimer = setTimeout(() => {
      setIsStale(true);
    }, 60000);
    return () => clearTimeout(staleTimer);
  }, [progressData, jobId]);

  const handleClose = () => {
    removeJob(jobId);
  };

  return (
    <div className="self-end p-4 bg-[#CAFDF5] shadow-[0px_4px_16px_0px_#00000040] rounded-lg w-[350px]">
      <div>
        <div className="flex justify-between items-center">
          <span className="text-xs font-semibold text-[#637381] leading-[18px]">
            {progressData.message}
          </span>
        </div>

        <div className="flex items-center gap-3 justify-between my-1">
          <span className="text-[#212B36] text-sm leading-[22px]">
            {progressData.progress}% completed
          </span>
          {isStale && (
            <button
              onClick={handleClose}
              className="text-xs font-semibold text-[#637381] leading-[18px] hover:underline"
            >
              Close
            </button>
          )}
        </div>

        <div className="bg-white rounded-full h-2 w-full">
          <div
            className="bg-[#00B8D9] h-2 rounded-full"
            style={{ width: `${progressData.progress}%`, transition: 'width 1s ease-in-out' }}
          />
        </div>
      </div>
    </div>
  );
};

export default JobProgressToast;
